export default class BaseApi {
  http;
  constructor(http) {
    this.http = http;
  }
}
